/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramClickControllerCreateMutationRequest,
  TelegramClickControllerCreateMutationResponse,
  TelegramClickControllerCreate401,
} from '../../types/TelegramClickControllerCreate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramClickCreate } from '../../methods/telegramClickCreate.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramClickCreateMutationKey = () => [{ url: '/api/telegram/click' }] as const;

export type TelegramClickCreateMutationKey = ReturnType<typeof telegramClickCreateMutationKey>;

/**
 * {@link /api/telegram/click}
 */
export function useTelegramClickCreate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramClickControllerCreateMutationResponse,
      ResponseErrorConfig<TelegramClickControllerCreate401>,
      { data: TelegramClickControllerCreateMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramClickControllerCreateMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramClickCreateMutationKey();

  return useMutation<
    TelegramClickControllerCreateMutationResponse,
    ResponseErrorConfig<TelegramClickControllerCreate401>,
    { data: TelegramClickControllerCreateMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramClickCreate(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
